import {useCallback} from "react";
import {getQueryResults} from "../api/duckdb/getQueryResults";

/**
 * Funkcja wyciągnięta, aby można było użyc w komponencie klasowym a nie na hookach
 * @param {*} query
 * @param {*} params
 * @returns
 */
export async function queryCallerFunction(query, params) {
    try {
        const res = await getQueryResults({
            Queries: [{SQL: query, Parameters: params}],
        });
        const queryResult = res.QueriesResults[0];
        if (queryResult.ExecCode === "FAIL") {
            console.error(queryResult.Error);
            console.error("Failed to execute query", {
                error: queryResult.Error,
                res: queryResult,
                query,
                params,
            });
            return [];
        }
        console.log("Result", {queryResult, query, params});
        return queryResult.Data;
    } catch (e) {
        console.error(e);
        return [];
    }
}

export default function useQueryCaller() {
    return useCallback(async (query, params) => {
        return await queryCallerFunction(query, params);
    }, []);
}
